
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      //import css for availability and price pages
var ReservationInformation;
var searchbarGlobal;
import $$ from 'Dom7';
import actions from '../js/actions.js';
import URLS from '../js/Urls.js';
export default {
  data: function () {
    return {
      ReservationDetails: {},
      ReservationInformation: {},
      Name: {},
      loginobject: {},
      ResponseGetMonthlyResData: {}
    };
  },

  beforeDestroy() {
    var self = this;
    console.log('componentBeforeDestroy', this);
  },

  methods: {},
  on: {
    pageBeforeInit: function (e, page) {},
    pageInit: async function (e, page) {
      var self = this;
      var obj = JSON.parse(localStorage.getItem("Notassigned"));
      var loginobject = actions.LoginGetResult();
      var currency = actions.GetUserCurrency();
      let response = app.f7.request.promise.postJSON(URLS.SearchNotAssignedReservations, {
        obj
      }).then(res => {
        app.f7.preloader.hide();
        self.$setState({
          SearchResult: res.data
        });
      });
      $$(".price-span").text(currency);

      try {
        app.f7.preloader.show();
        let response = await app.f7.request.promise.postJSON(URLS.SearchNotAssignedReservations, {
          obj
        });
        app.f7.preloader.hide();
        localStorage.setItem("ReservationInfo", JSON.stringify(response.data.CustomerReservations[0]));
        app.f7.views.main.router.navigate('/reservation-info/', {
          transition: 'f7-dive'
        });
        app.preloader.hide();
      } catch (error) {
        console.log(error);
      }

      $$(".page-content").on('click', ".reservationcardbtn", async function (event) {
        let $target = $(event.target);
        let $label = $target.closest('.reservationcardbtn').find('.reservcode');
        let ReservationID = $label.attr("id");
        obj = {
          PropertyID: loginobject.PropertyID,
          UserID: loginobject.UserID,
          ReservationID: ReservationID
        };

        try {
          // let response = await app.f7.request.promise.postJSON(URLS.GetReservationDetails, { obj })
          // app.f7.preloader.hide();
          localStorage.setItem("ReservationID", JSON.stringify(ReservationID));
          app.f7.views.main.router.navigate('/reservation-info/', {
            transition: 'f7-dive'
          }); //console.warn(response);
        } catch (error) {
          console.log(error);
        }
      });
    },

    pageBeforeRemove() {}

  },
  id: '3d53e40fb2',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class="page maincontaint" data-name=new-reservation-home><!-- Top Navbar --><!-- Top Navbar --><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a class="link back"><i class="icon icon-back"></i></a></div><div class=title>Not assigned Reservations</div></div></div><div class="page-content reservationspage"><div class=list><ul class=rescard style=padding-left:0px;>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.SearchResult, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="card reservationcardbtn"><div class="card-content card-content-padding"><li class=item-content style="display: block;padding-top: 5px;padding-bottom: 5px;"><div class=event-color style="background-color: ';
          r += c(ctx_2.color, ctx_2);
          r += '"></div><div class=row><div class=col-80 style=font-weight:600;>';
          r += c(ctx_2.CustomerFirstName, ctx_2);
          r += ' ';
          r += c(ctx_2.CustomerLastName, ctx_2);
          r += ' <span class="badge color-blue Reservation">';
          r += c(ctx_2.ChannelManagerName, ctx_2);
          r += '</span></div><div class="col-20 Price totalpriceroom">';
          r += c(ctx_2.TotalPrice, ctx_2);
          r += ' <span class=price-span></span></div></div><div class=row><div class="col-80 reservcode" id=';
          r += c(ctx_2.ReservationID, ctx_2);
          r += '>Res. cod. ';
          r += c(ctx_2.ResID, ctx_2);
          r += '</div><!-- <div class="col-20">\r\n                        <i class="material-icons myicon">\r\n                          keyboard_arrow_right\r\n                        </i>\r\n                      </div> --></div><div class=row><div class=col-100>';
          r += c(ctx_2.RoomName, ctx_2);
          r += ', ';
          r += c(ctx_2.RoomTypeStr, ctx_2);
          r += '</div></div><div class=row><div class=col-100>';
          r += c(ctx_2.Nights, ctx_2);
          r += ' Night - ';
          r += c(ctx_2.TotalGuests, ctx_2);
          r += ' guests - 1 Room</div><!-- <div class="col-40 minutes">\r\n                        Before ';
          r += c(ctx_2.TimeBeforeStr, ctx_2);
          r += '\r\n                      </div> --></div></li></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</ul></div></div></div>';
      return r;
    }(this);
  },

  style: `
  .totalpriceroom {
    color: black;
  }
`,
  styleScoped: false
};
    